import { render, staticRenderFns } from "./Agendamentos72h.vue?vue&type=template&id=27f65be2"
import script from "./Agendamentos72h.vue?vue&type=script&lang=js"
export * from "./Agendamentos72h.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports